module.exports = __webpack_public_path__ + "static/media/stats_icon.3ca0c261.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stats_icon.svg
// module id = 1230
// module chunks = 0